/**
 * The shadcn focus-visible treatment (`ui/button-variants.ts`, `ui/select-variants.ts`) for the
 * toolbar's borderless controls, so keyboard focus looks the same on every one of them instead of
 * mixing the browser's native outline with shadcn's ring (WMPCM-12967). `outline-none` drops the
 * native ring; the ring is a box-shadow, so `relative z-10` lifts the focused control above its
 * neighbours in a segmented group, which would otherwise paint over it. A `border-ring` is left out
 * because these controls are `border-none` and the group box owns the border.
 */
export const FOCUS_RING_CLASS =
  'outline-none focus-visible:relative focus-visible:z-10 focus-visible:ring-[3px] focus-visible:ring-ring/50'
